import type { Components, Theme } from "@mui/material";

export const formHelperTextTheme: Components<Theme>["MuiFormHelperText"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      marginLeft: 0,
      marginRight: 0,
      fontSize: theme.typography.body3.fontSize,
      "&.Mui-error": {
        color: theme.palette.errorSecondary.contrastText,
      },
    }),
  },
};
